/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 11/21/2011
 * Copyright All Rights Reserved
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import PrivateRoute from 'containers/PrivateRouteContainer';
import SignIn from 'components/SignInPage';
import Inputs from 'components/InputsPage';
import List from 'containers/ListContainer';
import Terms from 'components/TermsPage';

/**
 * Defines the app's root component and router. Also makes Redux store
 * available to all sub-components
 */
const RootContainer = ({ store }) => (
  <Provider store={store}>
    <Router>
      <div>
        <Route exact path="/" component={SignIn} />
        <Route exact path="/terms" component={Terms} />
        <Route path="/sign-in" component={SignIn} />
        <PrivateRoute store={store} path="/inputs" component={Inputs} />
        <PrivateRoute store={store} path="/list" component={List} />
      </div>
    </Router>
  </Provider>
);

RootContainer.propTypes = {
  store: PropTypes.shape({
    dispatch: PropTypes.func.isRequired,
    getState: PropTypes.func.isRequired,
    replaceReducer: PropTypes.func.isRequired,
    subscribe: PropTypes.func.isRequired,
  }).isRequired,
};

export default RootContainer;
